<div class="dashboardNotes">
    <div class="header-block">
        <div class="btn-card notes-grid">
            <div class="row k-hstack">
                <div class="card-titile">
                    {{appConstants.ImportantNotesDasboardLabel}}
                </div>
                    <div class="functionalRole">
                        <app-tcc-single-select-field
                        [data]="functionalRole"
                        [control]="functionalRoleController"
                        valueField="teamId"
                        textField="teamName"
                        (valueChange)="functionalRoleChange()">
                        </app-tcc-single-select-field>
                    </div>
            </div>
        </div>
    </div>
    <div class="header-block grid-data">
        <div class="notes-grid">
            <kendo-grid
            id="dashboardNotes-list-grid"
            [data]="dashboardNotesData"
            [pageSize]="request.pageSize"
            [skip]="request.skip"
            [pageSize]="request.pageSize"
            [pageable]="appConstants.GridPagerSettings"
            [resizable]="true"
            [reorderable]="true"
            (pageChange)="onPageChange($event)">
        
            <ng-template kendoGridNoRecordsTemplate>
            <span class="norecord-font" *ngIf="showNoRecordMesage == true">{{
                appConstants.NoNotesFoundError
            }}</span>
            </ng-template>
            <kendo-grid-column
            *ngFor="let column of dashboardNoteColumns"
            [field]="column.field"
            [title]="column.title"
            [ngSwitch]="column.field"
            [sortable]="column.sortable"
            [reorderable]="!column.sticky"
            [filterable]="column.filterable"
            [width]="column.width"
            [class]="column.class"
            [hidden]="column.hidden"
            [sticky]="column.sticky"
            [headerClass]="column.headerClass"
            >
            @switch (column.field) { 
                @case ('jobID') {
                    <ng-template kendoGridHeaderTemplate>
                        <span class="k-icon k-font-icon k-i-data"></span>
                        <span class="ml-2">{{appConstants.TCCImportantNotesLabel}}</span>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                        <div class="card-message">
                            <div class="message-bar">
                                <div class="note-message">
                                    <span class="k-icon k-font-icon k-i-exclamation-circle"></span>&nbsp; 
                                    <span>{{dataItem.jobName}}</span>&nbsp;:&nbsp;
                                    <span class="noteMessage">{{dataItem.noteMessage}}</span>
                                </div>
                                <div class="padding-left-24px">
                                    {{dataItem.modifiedDate | hoursAgo}} &nbsp;{{ dataItem.jobId }}
                                </div>
                            </div>
                        </div>
                    </ng-template>
                }
            }
            </kendo-grid-column>
        </kendo-grid>
        </div>
    </div>
</div>
<div kendoDialogContainer #dialogContainer></div>